import { Component, Input, OnInit } from '@angular/core';
import { SasisopaService } from '../../../../../services/sasisopa.service';
import { NbDialogRef } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';

type ReviewResult = {
  title: string;
  criterio: string;
  evaluation: string;
  name_of_responsibles: string;
  name_of_members: string;
  conclusion: string;
  date_of_revision: string;
  activities: string;
  resources: string;
  responsible: string;
  date_ejecution: string;
}

type ReviewResults = {
  station_id: string;
  indicators: ReviewResult;
  results: ReviewResult;
  evaluations: ReviewResult;
  comunications: ReviewResult;
  degree_of_compliance: ReviewResult;
  state_of_compliance: ReviewResult;
  follow_of_actions: ReviewResult;
  changes: ReviewResult;
  recommendations: ReviewResult;
}

@Component({
  selector: 'ngx-review-results-form',
  templateUrl: './review-results-form.component.html',
  styleUrls: ['./review-results-form.component.scss']
})
export class ReviewResultsFormComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: ReviewResults & { id: string };
  loading = false;
  keys = [
    'indicators',
    'results',
    'evaluations',
    'comunications',
    'degree_of_compliance',
    'state_of_compliance',
    'follow_of_actions',
    'changes',
    'recommendations',
  ]
  data: ReviewResults = {
    station_id: '',
    indicators: { title: '1. Indicadores de Desempeño de Seguridad Industrial, Seguridad Operativa y Protección al Medio Ambiente.', criterio: 'test test', evaluation: 'test test', name_of_members: 'test test', name_of_responsibles: 'test test', conclusion: 'test test ', activities: 'test test', resources: 'test test', date_ejecution: '', date_of_revision: '', responsible: 'test test' },
    results: { title: '2. Los resultados de las Auditorías', criterio: 'test test', evaluation: 'test test', name_of_members: 'test test', name_of_responsibles: 'test test', conclusion: 'test test ', activities: 'test test', resources: 'test test', date_ejecution: '', date_of_revision: '', responsible: 'test test' },
    evaluations: { title: '3. Evaluaciones de cumplimiento con los requisitos legales y otros.', criterio: 'test test', evaluation: 'test test', name_of_members: 'test test', name_of_responsibles: 'test test', conclusion: 'test test ', activities: 'test test', resources: 'test test', date_ejecution: '', date_of_revision: '', responsible: 'test test' },
    comunications: { title: '4. Las comunicaciones con las partes interesadas externas, incluyendo quejas y sugerencias', criterio: 'test test', evaluation: 'test test', name_of_members: 'test test', name_of_responsibles: 'test test', conclusion: 'test test ', activities: 'test test', resources: 'test test', date_ejecution: '', date_of_revision: '', responsible: 'test test' },
    degree_of_compliance: { title: '5. El grado de cumplimiento de los objetivos y metas.', criterio: 'test test', evaluation: 'test test', name_of_members: 'test test', name_of_responsibles: 'test test', conclusion: 'test test ', activities: 'test test', resources: 'test test', date_ejecution: '', date_of_revision: '', responsible: 'test test' },
    state_of_compliance: { title: '6. El estado de las acciones aplicadas para la administración de Hallazgos.', criterio: 'test test', evaluation: 'test test', name_of_members: 'test test', name_of_responsibles: 'test test', conclusion: 'test test ', activities: 'test test', resources: 'test test', date_ejecution: '', date_of_revision: '', responsible: 'test test' },
    follow_of_actions: { title: '7. El seguimiento de las acciones resultantes de las revisiones previas llevadas a cabo por el Regulado a su Sistema de Administración.', criterio: 'test test', evaluation: 'test test', name_of_members: 'test test', name_of_responsibles: 'test test', conclusion: 'test test ', activities: 'test test', resources: 'test test', date_ejecution: '', date_of_revision: '', responsible: 'test test' },
    changes: { title: '8. Los cambios en las circunstancias, incluyendo las actualizaciones del marco normativo aplicable.', criterio: 'test test', evaluation: 'test test', name_of_members: 'test test', name_of_responsibles: 'test test', conclusion: 'test test ', activities: 'test test', resources: 'test test', date_ejecution: '', date_of_revision: '', responsible: 'test test' },
    recommendations: { title: '9. Las recomendaciones para la mejora.', criterio: 'test test', evaluation: 'test test', name_of_members: 'test test', name_of_responsibles: 'test test', conclusion: 'test test ', activities: 'test test', resources: 'test test', date_ejecution: '', date_of_revision: '', responsible: 'test test' },
  };

  constructor(
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<ReviewResultsFormComponent>,
  ) { }

  async ngOnInit() {
    this.loading = true;
    await this.checkIfCreateOrEdit();
    this.loading = false;
  }

  async store() {
    this.data.station_id = this.stationId;
    this.loading = true;
    const [error] = await this.sasisopaService.createReviewResults(this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Registro creado con éxito', 'success');
    this.ref.close(true);
  }

  async edit() {
    this.loading = true;
    this.data.station_id = this.stationId;
    const [error] = await this.sasisopaService.editReviewResults(this.infoEdit.id, this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Registro editado con éxito', 'success');
    this.ref.close(true);
  }

  handleSubmit() {
    if (this.action === 'edit') {
      this.edit();
    } else {
      this.store();
    }
  }

  alert(title: string = '', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async checkIfCreateOrEdit() {
    if (this.action === 'edit') this.data = this.infoEdit
  }
}
